export default {
    url: '/licence-point',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/licencepoint/index.js